import React, { useContext } from "react";
import { BotonEditar, BotonEliminar } from "../layout/FormsElements";
import { AuthContext } from ".";

const Solicitud = ({ item, editar, eliminar, soloLectura, esadmin, subasta }) => {
  const authContext = useContext(AuthContext);
  const { usuario } = authContext;

  const estado = () => {
    //console.log(precios);
    switch (item.idestado) {
      case "1":
        return "En Evaluacion";
      case "2":
        return "Aprobado";
      case "3":
        return "Rechazado";
      default:
        break;
    }
  };

  return (
    <tr>
      <td className="text-center">{item.nombre}</td>
      <td className="text-center">{item.descripcion}</td>
      <td className="text-center">{item.cantidad}</td>
      {esadmin === "1" ? (
        <td className="text-center">{item.razonsocial}</td>
      ) : null}
      {esadmin === "1" ? (
        <td className="text-center">{/* {item.razonsocial} */}</td>
      ) : null}
      <td className="text-center">{estado()}</td>
      <td className="text-center">
        {!soloLectura || item.idestado !== "2" ? (
          <>
            <BotonEditar editar={editar} item={item} />
            {item.idusuario === usuario.id ? (
              <BotonEliminar eliminar={eliminar} item={item} />
            ) : null}
          </>
        ) : null}
        {esadmin === "1" && item.idestado === "2" ? (
          <BotonEditar editar={subasta} item={item} label={"Subasta"} />
        ) : null}
      </td>
    </tr>
  );
};

export default Solicitud;
